import React from "react";
import { Text } from "@chakra-ui/react";

const smallUppercaseWithletterSpace = {
  fontWeight: "800",
  fontSize: "10px",
  lineHeight: "1.5",
  color: "#0E3665",
  fontFamily: "Nunito",
  textTransform: "uppercase",
  letterSpacing: "1px",
};

const SubHeading = ({ subHeadingLabel, ...props }) => {
  return (
    <Text {...smallUppercaseWithletterSpace} {...props}>
      {subHeadingLabel}
    </Text>
  );
};

export default SubHeading;
